import React, { useMemo } from "react";
// import ReactSWF from 'react-swf';

const VideoStyle = {
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  paddingTop: "2rem",
};

function Audio(props) {
  const url = useMemo(() => {
    return props.link || props.location?.useProps?.fileUrl || props.fileUrl;
  }, [props]);
  return (
    <div style={VideoStyle}>
      <video
        width="60%"
        style={{ marginTop: "2rem" }}
        controls
        controlsList="nodownload"
      >
        <source src={url} type="video/mp4" />
        Your browser does not support HTML video.
      </video>
    </div>
  );
}

export default Audio;
